import { render, staticRenderFns } from "./b2bChannel.vue?vue&type=template&id=0984baf7&scoped=true"
import script from "./b2bChannel.vue?vue&type=script&lang=js"
export * from "./b2bChannel.vue?vue&type=script&lang=js"
import style0 from "./b2bChannel.vue?vue&type=style&index=0&id=0984baf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984baf7",
  null
  
)

export default component.exports